"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonAliases = void 0;
var getReusedHoverColor = function (colors, brand) {
    if (brand === 'valtra') {
        return colors.primary.black;
    }
    if (brand === 'fendt') {
        return colors.secondary.shades[600];
    }
    return colors.secondary.brand;
};
var getDisabledColors = function (colors, brand) {
    var grays = colors.primary.grays;
    switch (brand) {
        case 'valtra':
            return {
                disabled: grays[200],
                disabledStrokeColor: grays[600],
            };
        case 'massey':
            return {
                disabled: grays[200],
                disabledStrokeColor: grays[400],
            };
        case 'agco':
        default:
            return {
                disabled: grays[400],
                disabledStrokeColor: grays[200],
            };
    }
};
var getButtonFontFamily = function (brand, fonts) {
    if (brand === 'massey') {
        return fonts.secondary.regular;
    }
    return fonts.primary.bold;
};
var getButtonTextTransform = function (brand) {
    if (brand === 'valtra') {
        return 'uppercase';
    }
    return 'none';
};
var getButtonAliases = function (globals, brand) {
    var colors = globals.colors, _a = globals.colors, primary = _a.primary, white = _a.primary.white, secondary = _a.secondary, _b = globals.units.button, borderRadius = _b.borderRadius, fontSizes = _b.fontSizes, paddings = _b.paddings, fonts = globals.fonts;
    var _c = getDisabledColors(globals.colors, brand), disabled = _c.disabled, disabledStrokeColor = _c.disabledStrokeColor;
    return {
        stateColors: {
            default: primary.brand,
            hover: getReusedHoverColor(colors, brand),
            active: secondary.brand,
            disabled: disabled,
        },
        strokeColor: white,
        borderRadius: borderRadius,
        disabledStrokeColor: disabledStrokeColor,
        height: {
            lg: 48,
            md: 40,
            sm: 32,
        },
        fontSizes: fontSizes,
        paddings: paddings,
        textTransform: getButtonTextTransform(brand),
        fontFamily: getButtonFontFamily(brand, fonts),
    };
};
exports.getButtonAliases = getButtonAliases;
